export { DetailModel } from './Detail.model';
export { MainModel } from './Main.model';
